var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCadastroDeLote = function SvgCadastroDeLote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M21.624 25.9l.001-13.631.007-.168a2.5 2.5 0 0 1 2.493-2.314H26.5V2.4A1.5 1.5 0 0 0 25 .9H3a1.5 1.5 0 0 0-1.5 1.5v22A1.5 1.5 0 0 0 3 25.9h18.624z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 5,
    x: 0.5,
    y: 0.9,
    fill: "url(#b)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6,
    x: 9,
    y: 12.4,
    fill: "#7A7B8E",
    rx: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    stroke: "#D3D4DD",
    d: "M29.415 14.9h-2.83v2.465h-1.73c-.209 0-.355.13-.355.258v10.019c0 .128.146.258.355.258h6.29c.209 0 .355-.13.355-.258V17.623c0-.128-.146-.258-.355-.258h-1.73V14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8C54",
    d: "M25 21.4h6v6h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M32 14.4v-2a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCadastroDeLote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cadastro-de-lote.1571e27f.svg";
export { ForwardRef as ReactComponent };